export const NOT_FOUND_SCREEN = {
  DESCRIPTION: "We're having trouble finding the page you're looking for.",
  SUPPORT_TEXT: 'If the problem persists, please contact us for help.',
  ARIA_ICON_TITLE: 'Not found icon',
};
